import ReactDOM from 'react-dom';

import App from './App';
import './index.css';

// NOSONAR: Prevencion de clickjacking / cross-frame scripting
if (window.top !== window.self) {
  window.top.location = window.location.href;
}

ReactDOM.render(<App />, document.getElementById('root'));
